export default __webpack_public_path__ + "static/char-34-anr-545da701ea15e1bd7c6bdde19e17322c.gif";